document.addEventListener('DOMContentLoaded', () => {
    const tabButtons = document.querySelectorAll('.ssc-tab-option button');
    const tabContents = document.querySelectorAll('.ssc-tab-content-wrapper .wp-block-custom-blocks-service-showcase-tab-content');


    console.log(tabButtons);
    console.log(tabContents);

    // Añadir la clase 'active' al primer botón y contenido
    if (tabButtons.length > 0 && tabContents.length > 0) {
        tabButtons[0].classList.add('active');
        tabContents[0].classList.add('active');
    }

    tabButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
            // Remover la clase 'active' de todos los botones
            tabButtons.forEach((btn) => {
                btn.classList.remove('active');
            });

            // Añadir la clase 'active' al botón actual
            e.target.classList.add('active');

            // Remover la clase 'active' de todos los contenidos
            tabContents.forEach((content) => {
                content.classList.remove('active');
            });

            // Añadir la clase 'active' al contenido actual
            tabContents[index].classList.add('active');
        });
    });

    var swiper = new Swiper('.swiper-container-custom', {
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 16,
        loop: true,
        autoplay: true,
        centeredSlides: false,
        speed: 3000,
        effect: 'slide',
    });



});